import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { LanguageLoader } from "../../assets/languages";

const Table = ({children=[], header, SortCallback, itemsPerPage, counter, title, reset, className=''}) =>
{
	const preferences = useSelector((state) => state.preferences);
	const language = LanguageLoader(preferences.language);
	const [sortField, SetSortField] = useState('');
	const [sortOrder, SetSortOrder] = useState('');
	const [currentPage, SetCurrentPage] = useState(1);
	const startIndex = itemsPerPage ? (currentPage - 1) * itemsPerPage : 0;
	const endIndex = itemsPerPage ? startIndex + itemsPerPage : children.length;
	const shouldRenderPagination = children.length > itemsPerPage;
	const lastPage = Math.ceil(children.length / itemsPerPage);


	useEffect(() =>
	{
		if(reset)
		{
			SetCurrentPage(1);
		}
	// eslint-disable-next-line
	}, [reset]);

	const pageNumbers = [];
	for (let i = 1; i <= lastPage; i++)
	{
		pageNumbers.push(i);
	}

	const Sort = (fieldname) =>
	{
		if(SortCallback)
		{
			let data = {
				'field': sortField,
				'order': sortOrder,
			};
			if(fieldname !== data.field)
			{
				SetSortField(fieldname);
				SetSortOrder('ASC');
				data = {
					'field': fieldname,
					'order': 'ASC',
				};
			}
			else if(sortOrder === 'DESC')
			{
				SetSortOrder('ASC');
				data.order = 'ASC';
			}
			else
			{
				SetSortOrder('DESC');
				data.order = 'DESC';
			}
			SortCallback(data);
		}
	}

	return(
		<>
		{title || counter ?
		<div className="px-1 mb-4 text-sm">
			<span>{title ? title : counter ? language.TOTAL_RESULT : null}</span>
			{counter ? <span className="text-xs bg-primary py-1 px-2 text-white rounded-lg mx-3">{children.length}</span> : null}
		</div>
		: null 
		}
		<table className={"table table-striped "+className}>
			{Object.keys(header).length ? <thead>
				<tr>
				{Object.keys(header).map((column, index) => <th key={index} onClick={() => Sort(column)} className={SortCallback ? 'cursor-pointer hover:text-primary' : null}>
					{header[column]}
					{sortField === column ? <i className={sortOrder === 'DESC' ?"fa fa-sort-up mx-4" : "fa fa-sort-down mx-4"}></i> : null}
				</th>)}
				</tr>
			</thead> : null}
			<tbody>
				{children.length ? children.map(({props}, index) =>
				{

					let visibility = ( index >= startIndex && index < endIndex) ? '' : 'hidden';
					return <tr key={index} className={visibility}>{props.children}</tr>
				}) : <tr><td colSpan={Object.keys(header).length}>{language.NO_DATA}</td></tr>}
			</tbody>
		</table>
		{shouldRenderPagination && (
			<ul className="pagination">
				<li className={currentPage === 1 ? 'disabled' : null} onClick={() => SetCurrentPage(currentPage - 1)}><i className="fa fa-caret-right"></i></li>
				<li onClick={() => SetCurrentPage(1)} className={currentPage === 1 ? 'active' : ''}>{1}</li>
				{pageNumbers.map((number, index) =>
				{
					if(number === 1 || number === lastPage)
					{
						if(number === 1 && currentPage > 4)
						{
							return <li key={index} className="pointer-events-none">...</li>
						}
						else if(number === lastPage && currentPage < lastPage-3 )
						{
							return <li key={index} className="pointer-events-none">...</li>
						}
					}
					else if(number <= (currentPage+2) && number >= (currentPage-2))
					{
						return <li key={index} onClick={() => SetCurrentPage(number)} className={currentPage === number ? 'active' : ''}>{number}</li>
					}
					return null;
				})}
				<li onClick={() => SetCurrentPage(lastPage)} className={lastPage === 1 ? 'active' : ''}>{lastPage}</li>
				<li onClick={() => SetCurrentPage(currentPage + 1)} className={endIndex >= children.length ? 'disabled':null}><i className="fa fa-caret-left"></i></li>
			</ul>
		)}
		</>
	)
}

export default Table;